import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/img/UsuarioAvatar.png'


const _withScopeId = n => (_pushScopeId("data-v-5a68f3b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "user-toolbar-container"
}
const _hoisted_2 = { class: "dvAvatar-commands" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-replay" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "pi pi-bell"
}
const _hoisted_6 = {
  key: 1,
  class: "pi pi-bell"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cog" }, null, -1))
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "dvAvatar-info" }
const _hoisted_10 = { class: "w-100 text-short" }
const _hoisted_11 = { class: "w-100 text-short" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-power-off",
  style: {"font-weight":"bold"}
}, null, -1))
const _hoisted_13 = {
  key: 0,
  style: {"margin-left":"12px"}
}
const _hoisted_14 = { class: "dvAvatar" }
const _hoisted_15 = ["src"]
const _hoisted_16 = {
  key: 1,
  src: _imports_0
}
const _hoisted_17 = {
  key: 1,
  class: "w-100"
}
const _hoisted_18 = { class: "col-footer col-footer-commands" }
const _hoisted_19 = { class: "dvAvatar-commands-footer-app" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-replay" }, null, -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "dvAvatar-commands-footer-app" }
const _hoisted_23 = {
  style: {"height":"inherit","width":"100%"},
  class: "dvAvatar-commands-footer-app-notis"
}
const _hoisted_24 = {
  key: 0,
  class: "pi pi-bell"
}
const _hoisted_25 = {
  key: 1,
  class: "pi pi-bell"
}
const _hoisted_26 = { class: "dvAvatar-commands-footer-app" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-cog" }, null, -1))
const _hoisted_28 = [
  _hoisted_27
]
const _hoisted_29 = { class: "col-footer col-footer-avatar" }
const _hoisted_30 = { class: "dv-avatar-img" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 1,
  src: _imports_0
}
const _hoisted_33 = { class: "dv-avatar-info" }
const _hoisted_34 = { class: "w-100 text-short dv-avatar-info-name" }
const _hoisted_35 = { style: {"margin-left":"3px"} }
const _hoisted_36 = { class: "w-100 text-short dv-avatar-info-profile" }
const _hoisted_37 = { key: 0 }

import { ISesionApp } from '@/model/ISesionApp';
import { PropType, computed, ref, onMounted, onUnmounted } from 'vue';
import {eCommnadsToolbar} from '@/model/GloblasEnum';
import { useServicesFactoryStore }  from '@/store/services-factory-store';
import { ISesionUsuarios } from '@/model/ISesionUsuarios';
import { traduceTexto } from '@/services/ui/GlobalFunctions';
import { Subscription} from "rxjs";
import {ChatService} from '@/services/ChatService';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserToolbar',
  props: {
 tipo: Number,
 sesionApp: {type:Object as PropType<ISesionApp>, required:true},
 hubSesion: { type: Object as PropType<ISesionUsuarios>, required:true }
},
  emits: ['onCommand'],
  setup(__props, { emit: __emit }) {

const chatService:ChatService = useServicesFactoryStore().getChatService;
const uiManager = useServicesFactoryStore().getUIManager;
const props = __props;
const emits = __emit;
const perfil = props.sesionApp.SyncData.getPerfil();
const proveedorPerfil = traduceTexto('globals.proveedor');
const clienteproveedorPerfil = traduceTexto('globals.cliente');
const appUserPerfil = traduceTexto('globals.noPerfil');
const TotalNotis = ref<number>(0); 
let NewMessagesTotalSubscription: Subscription;
const profileImg = computed(():string => 
{
    return uiManager.getProfileImageAppUser(props.sesionApp);
});
const onCommand = (val:any)=>
{    
   emits('onCommand',{type:val});
}
const signalRActive = computed(() => 
{
  return props.sesionApp.SyncData.SignalRActive;
})
const isOnline = computed(() => {
  return props.hubSesion && props.hubSesion.TokenHub ? true:false;
})
const perfilName = computed(():string => 
{
  if(perfil) return  perfil.NombrePerfil;
  else if(props.sesionApp.SyncData.isProveedor()) return proveedorPerfil;
  else if(props.sesionApp.SyncData.isCliente()) return clienteproveedorPerfil;
  else return appUserPerfil;
})
onMounted(async ()=>
{                   
   NewMessagesTotalSubscription = chatService.NewMessagesTotal.subscribe((total: any) => 
   {        
    TotalNotis.value = total;
   }); 
});
onUnmounted(()=>
{
    if (NewMessagesTotalSubscription)
    {        
        NewMessagesTotalSubscription.unsubscribe();
    }
});

return (_ctx: any,_cache: any) => {
  const _directive_badge = _resolveDirective("badge")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.tipo === 1 || __props.tipo === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_unref(uiManager).ReloadCurrentAction)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {onCommand(_unref(eCommnadsToolbar).reload);})
                }, _hoisted_4))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              (TotalNotis.value)
                ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_5, null, 512)), [
                    [
                      _directive_badge,
                      TotalNotis.value>100 ?'99+':TotalNotis.value,
                      void 0,
                      { danger: true }
                    ]
                  ])
                : (_openBlock(), _createElementBlock("i", _hoisted_6))
            ]),
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => {onCommand(_unref(eCommnadsToolbar).options);})
            }, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              (signalRActive.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["status statusMobil", { 'OnLine':isOnline.value,'OffLine':!isOnline.value}])
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("b", null, _toDisplayString(__props.sesionApp.User?.FullName()), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "dv-logoff",
                onClick: _cache[2] || (_cache[2] = ($event: any) => {onCommand(_unref(eCommnadsToolbar).logof);})
              }, [
                _hoisted_12,
                (perfilName.value)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(perfilName.value), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (profileImg.value)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: profileImg.value,
                  class: "s-tool-img-profile"
                }, null, 8, _hoisted_15))
              : (_openBlock(), _createElementBlock("img", _hoisted_16)),
            (signalRActive.value)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 2,
                  class: _normalizeClass(["position-absolute p-1 rounded-circle", { 'OnLine':isOnline.value,'OffLine':!isOnline.value}])
                }, null, 2))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.tipo === 3.1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_19, [
                (_unref(uiManager).ReloadCurrentAction)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => {onCommand(_unref(eCommnadsToolbar).reload);}),
                      style: {"height":"inherit","width":"100%"}
                    }, _hoisted_21))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (TotalNotis.value)
                    ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_24, null, 512)), [
                        [
                          _directive_badge,
                          TotalNotis.value>100 ?'99+':TotalNotis.value,
                          void 0,
                          { danger: true }
                        ]
                      ])
                    : (_openBlock(), _createElementBlock("i", _hoisted_25))
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => {onCommand(_unref(eCommnadsToolbar).options);}),
                  style: {"height":"inherit","width":"100%"}
                }, _hoisted_28)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_30, [
                (profileImg.value)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: profileImg.value,
                      class: "s-tool-img-profile"
                    }, null, 8, _hoisted_31))
                  : (_openBlock(), _createElementBlock("img", _hoisted_32)),
                (signalRActive.value)
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 2,
                      class: _normalizeClass(["position-absolute p-1 rounded-circle", { 'OnLine':isOnline.value,'OffLine':!isOnline.value}])
                    }, null, 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("b", _hoisted_35, _toDisplayString(__props.sesionApp.User?.FullName()), 1)
                ]),
                _createElementVNode("div", _hoisted_36, [
                  (perfilName.value)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_37, _toDisplayString(perfilName.value), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})